var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.618,
    height: 18.147,
    viewBox: "0 0 12.618 18.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7 -2.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.07,20.59a1.382,1.382,0,0,0-.625,2.61v1.64h1.147V23.251a1.382,1.382,0,0,0-.522-2.661Z",
    transform: "translate(-3.709 -7.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,9.61V7.155A4.7,4.7,0,0,0,13.309,2.36,4.7,4.7,0,0,0,8.721,7.155V9.61H7v9.75a1.147,1.147,0,0,0,1.147,1.147H18.471a1.147,1.147,0,0,0,1.147-1.147V9.61ZM9.868,7.155a3.556,3.556,0,0,1,3.441-3.648A3.556,3.556,0,0,1,16.75,7.155V9.61H9.868ZM8.147,19.36v-8.6H18.471v8.6Z",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockLine);
export default __webpack_public_path__ + "static/media/lock-line.0de550b48c3ffa2e2675b878aaa402ee.svg";
export { ForwardRef as ReactComponent };